import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "typical-module"
};
var _hoisted_2 = {
  class: "typical-container"
};
var _hoisted_3 = {
  class: "top-nav"
};
var _hoisted_4 = {
  class: "typical-content"
};
var _hoisted_5 = {
  key: 0,
  class: "list-loading"
};
var _hoisted_6 = {
  key: 1,
  class: "typical-content-box"
};
import { onMounted, ref, computed, h } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { getStore } from '@/util/store';
import { routeAuth } from '@/utils/auth';
import SubjectTab from '../Common/SubjectTab.vue';
import components from './Type/component';
// 枚举
import { EXERCISE_TYPE_ENUM } from '@/const/enum';
import { getExerciseList, memberPeriodSubjectById } from '@/api/home';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var access_token = getStore({
      name: 'access_token'
    });
    var listData = ref([]); // 列表数据
    var loadingData = ref(false);
    var isFinish = ref(false);
    var current = ref(1);
    var subjectDictItemCode = ref('');
    var periodDictItemCode = ref('');

    // 习题类型
    var exerciseTypeComp = computed(function () {
      return function (type) {
        return EXERCISE_TYPE_ENUM[type];
      };
    });
    var isReady = ref(false);
    var handleChangeSubject = function handleChangeSubject(subject) {
      console.log(subject);
      subjectDictItemCode.value = subject.code;
      if (!isReady.value) return; // 首次加载由 refreshPage 统一发起请求
      isFinish.value = false;
      current.value = 1;
      getExercise();
    };
    var getExercise = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, _yield$getExerciseLis, data, _data$data, records, total, _listData$value, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(loadingData.value || isFinish.value)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              loadingData.value = true;
              params = {
                subject: subjectDictItemCode.value,
                size: 20,
                current: current.value
              }; // 当学段不为空时，添加学段筛选参数
              if (periodDictItemCode.value) {
                params.period = periodDictItemCode.value;
              }
              _context.n = 2;
              return getExerciseList(params);
            case 2:
              _yield$getExerciseLis = _context.v;
              data = _yield$getExerciseLis.data;
              _data$data = data.data, records = _data$data.records, total = _data$data.total; // 第一页用赋值，避免重复调用时数据叠加；后续分页用 push 追加
              if (current.value === 1) {
                listData.value = records || [];
              } else {
                (_listData$value = listData.value).push.apply(_listData$value, _toConsumableArray(records || []));
              }
              isFinish.value = 8 * current.value >= total;
              console.log(data);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log(_t);
            case 4:
              _context.p = 4;
              loadingData.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function getExercise() {
        return _ref.apply(this, arguments);
      };
    }();
    var handleScroll = function handleScroll(e) {
      var _e$target = e.target,
        scrollTop = _e$target.scrollTop,
        clientHeight = _e$target.clientHeight,
        scrollHeight = _e$target.scrollHeight;
      if (scrollHeight - (scrollTop + clientHeight) < 100 && !loadingData.value && !isFinish.value) {
        current.value++;
        getExercise();
      }
    };
    var goToExeciseDetail = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
        var hasAuth, url, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return routeAuth('typicalExercises');
            case 1:
              hasAuth = _context2.v;
              if (hasAuth) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, MessagePlugin.warning('暂无权限'));
            case 2:
              url = "".concat(window.location.origin, "/typicalExercises?typicalExercises=/sub-typical-exercises-svc/detail&resId=").concat(item.resId, "&token=").concat(access_token);
              window.open(url);
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.log(_t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 3]]);
      }));
      return function goToExeciseDetail(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var handleCreate = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var hasAuth, url, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return routeAuth('typicalExercises');
            case 1:
              hasAuth = _context3.v;
              if (hasAuth) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, MessagePlugin.warning('暂无权限'));
            case 2:
              url = "".concat(window.location.origin, "/typicalExercises?typicalExercises=/sub-typical-exercises-svc/home&token=").concat(access_token);
              window.open(url);
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              console.log(_t3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 3]]);
      }));
      return function handleCreate() {
        return _ref3.apply(this, arguments);
      };
    }();
    /**
     * 习题内容的渲染函数
     * @param props 传值
     * @param slots 插槽
     * @returns {VNode}
     * @constructor
     */
    var ExerciseCompRenderFunction = function ExerciseCompRenderFunction(props) {
      return h(components[props.type], {
        type: props.type,
        data: props.data,
        index: props.index + 1,
        answer: props.answer,
        options: props.options,
        onClick: function onClick() {
          if (props.data.visibleAddMenu) return;
          goToExeciseDetail(props.data);
          // router.push({
          //   path: "/detail",
          //   query: { resId: props.data.resId },
          // });
        }
      });
    };
    var refreshPage = function refreshPage() {
      current.value = 1;
      listData.value = [];
      loadingData.value = false;
      getExercise();
    };
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var accessInfo, _data$data2, _yield$memberPeriodSu, data, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            subjectDictItemCode.value = '';
            // 获取用户所在班级的默认学段
            accessInfo = getStore({
              name: 'accessInfo'
            }) || {};
            _context4.p = 1;
            _context4.n = 2;
            return memberPeriodSubjectById({
              userId: accessInfo.user_id
            });
          case 2:
            _yield$memberPeriodSu = _context4.v;
            data = _yield$memberPeriodSu.data;
            if (data !== null && data !== void 0 && (_data$data2 = data.data) !== null && _data$data2 !== void 0 && _data$data2.periodCode) {
              periodDictItemCode.value = data.data.periodCode;
            }
            _context4.n = 4;
            break;
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            console.log('获取默认学段失败', _t4);
          case 4:
            isReady.value = true;
            refreshPage();
          case 5:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3]]);
    })));
    return function (_ctx, _cache) {
      var _listData$value2, _listData$value3;
      var _component_Loading = _resolveComponent("Loading");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(SubjectTab, {
        "show-all": "",
        onChange: handleChangeSubject
      })]), _createElementVNode("div", _hoisted_4, [loadingData.value && !((_listData$value2 = listData.value) !== null && _listData$value2 !== void 0 && _listData$value2.length) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_Loading), _cache[0] || (_cache[0] = _createElementVNode("span", null, "加载中...", -1))])) : _createCommentVNode("", true), listData.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
        class: "list-class",
        onScroll: handleScroll
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, function (item, index) {
        var _item$exercise;
        return _openBlock(), _createBlock(ExerciseCompRenderFunction, {
          key: index,
          class: "exercise-list-item",
          type: exerciseTypeComp.value((_item$exercise = item.exercise) === null || _item$exercise === void 0 ? void 0 : _item$exercise.type),
          data: item,
          exercise: item.exercise,
          index: index
        }, null, 8, ["type", "data", "exercise", "index"]);
      }), 128))], 32), _createElementVNode("div", {
        class: "add-icon",
        onClick: handleCreate
      }, [_createVNode(_component_svg_icon, {
        name: "add-icon",
        size: "24"
      })])])) : _createCommentVNode("", true), !((_listData$value3 = listData.value) !== null && _listData$value3 !== void 0 && _listData$value3.length) && !loadingData.value ? (_openBlock(), _createBlock(_component_Empty, {
        key: 2,
        fullHeight: true,
        class: "empty-box"
      }, {
        description: _withCtx(function () {
          return [_cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "empty-text"
          }, "暂无内容", -1)), _createElementVNode("div", {
            class: "btn-class",
            onClick: handleCreate
          }, "手动创建")];
        }),
        _: 1
      })) : _createCommentVNode("", true)])])]);
    };
  }
};